
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cannabis-marijuana-laws/[slug]",
      function () {
        return require("private-next-pages/cannabis-marijuana-laws/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cannabis-marijuana-laws/[slug]"])
      });
    }
  